<template>
  <div class="header-wrapper">
    <div class="tabs-wrapper">
      <TabsBar />
    </div>
    <div class="user-info">
      <div class="binding-wechat" v-role="[2, 3, 5, 7, 9, 11, 13]">
        <span class="wechat-icon active" v-if="userInfo.bindStatus === 2"></span>
        <span class="wechat-icon inactive" @click="handleBindWeChat()" v-else></span>
      </div>
      <el-popover v-model="visible" popper-class="user-info-popover" placement="bottom-end" width="auto"
        trigger="click">
        <div>
          <div class="info-content">
            <p>Welcome,{{ userInfo.name }}</p>
            <p>
              Logged in as
              <span class="name">{{ userInfo.loginName }}</span>
            </p>
            <p v-role="[2,3,13]" @click="changeTA()" class="edit-TA"><i class="el-icon-edit"></i> Edit TA</p>
          </div>
          <div class="unbound-wechat" v-role="[2, 3, 5, 7, 9, 11, 13]" v-if="userInfo.bindStatus === 2"
            @click="unBindWeChat()">
            Unbound WeChat
          </div>
          <div class="logout-btn" @click="logout">Sign Out</div>
        </div>
        <span class="nickname" slot="reference">
          {{ userInfo.name }}
          <i class="el-icon-arrow-down el-icon--right" />
        </span>
      </el-popover>
    </div>
    <QrcodeDialog :visible.sync="qrcodeDialogVisible" />
    <TaInfoDialog :visible.sync="taInfoDialogVisible" />
  </div>
</template>

<script>
import TabsBar from './tabs-bar'
import QrcodeDialog from './qrcode-dialog'
import TaInfoDialog from './ta-info-dialog'
import Cookies from 'js-cookie'

export default {
  name: 'Header',
  components: { TabsBar, QrcodeDialog, TaInfoDialog },
  data() {
    return {
      visible: false,
      qrcodeDialogVisible: false,
      taInfoDialogVisible: false
    }
  },
  computed: {
    userInfo() {
      return this.$store.state.userInfo || {}
    },
    redirectUri() {
      const href = location.href
      const host = href.substring(0, href.indexOf(this.$route.path))
      return `${host}`
    },
  },
  created() {
    this.bus.$on('bindWeChat', this.handleBindWeChat)
  },
  methods: {
    changeTA() {
      this.taInfoDialogVisible = true
    },
    handleBindWeChat() {
      this.qrcodeDialogVisible = true
    },
    unBindWeChat() {
      this.$confirm(
        'Unbound wechat account, do you want to continue?',
        'Attention',
        {
          confirmButtonText: 'Confirm',
          cancelButtonText: 'Cancel',
          type: 'warning',
        }
      ).then(() => {
        this.axios.get('/user/unbind').then(({ code }) => {
          if (200 === code) {
            this.$store.commit('updateState', {
              userInfo: {
                ...this.userInfo,
                bindStatus: 0,
              },
            })
            this.$message.success('Unbound wechat successful')
          } else {
            this.$message.error('Unbound wechat failure')
          }
        })
      })
    },
    logout() {
      this.visible = false
      this.$confirm(
        'Logging out will clean up all cache data, do you want to continue?',
        'Attention',
        {
          confirmButtonText: 'Confirm',
          cancelButtonText: 'Cancel',
          type: 'warning',
        }
      )
        .then(() => {
          localStorage.removeItem('redirect')
          Cookies.remove('ACCESS_TOKEN')
          Cookies.remove(process.env.VUE_APP_COOKIE_KEY)
          window.location.href = `https://login.microsoftonline.com/common/oauth2/v2.0/logout?post_logout_redirect_uri=${encodeURI(
            this.redirectUri
          )}`
        })
        .catch(() => {
          this.visible = true
        })
    },
  },
}
</script>

<style lang="scss" scoped>
.header-wrapper {
  height: 50px;
  background-color: #f2f3f6;
  display: flex;
  align-items: flex-end;
  transition: background-color 0.2s;

  .tabs-wrapper {
    flex: 1;
  }

  .user-info {
    position: relative;
    line-height: 50px;
    padding: 0 20px;
    display: flex;

    &::before {
      position: absolute;
      top: 50%;
      left: 0%;
      width: 1px;
      height: 60%;
      border-left: 1px solid #c0c4cc;
      -webkit-transform: translateY(-50%);
      transform: translateY(-50%);
      content: ' ';
    }

    .binding-wechat {
      display: flex;
      align-items: center;
      margin-right: 10px;

      .wechat-icon {
        display: block;
        height: 20px;
        width: 20px;

        &.active {
          cursor: default;
          background: url(../../assets/img/wechat-actived.png) no-repeat center/cover;
        }

        &.inactive {
          background: url(../../assets/img/wechat-inactived.png) no-repeat center/cover;
        }
      }
    }

    span {
      color: #262627;
      cursor: pointer;
      display: flex;
      align-items: center;
      user-select: none;
      white-space: nowrap;

      i {
        font-weight: bold;
        line-height: 25px;
      }
    }
  }
}

.edit-TA {
  text-align: right;
  cursor: pointer;
}
</style>
